export enum UserPermissionsTableColumns {
  UserRole = "userRole",
  Leagues = "leagues",
  Competitions = "competitions",
  Seasons = "seasons",
  SeasonStatuses = "seasonStatuses",
  FixtureStatuses = "fixtureStatuses",
  EntityGroups = "entityGroups",
  Entities = "entities",
}
